import { defineMessages } from "react-intl";

const namespace = `partnershipInquiry`;
const partnershipInquiry = defineMessages({
  title: {
    id: `${namespace}.title`,
    description: "Page Title",
    defaultMessage: "Request to collab!"
  },
  description: {
    id: `${namespace}.description`,
    description: "Page Description",
    defaultMessage: `Looking to team up, request a sponsorship, or bring Evo energy to your event? This is the place to make it happen. Drop us a line with all the details of your request here.`
  },
  successMessage: {
    id: `${namespace}.successMessage`,
    description: "Success Message",
    defaultMessage: `Thanks for reaching out!`
  },
  successMessageDescription: {
    id: `${namespace}.successMessageDescription`,
    description: "Success Message Description",
    defaultMessage: `We’re fueled by great collabs so our team of humans will review your request and be in touch.`
  },
  firstName: {
    id: `${namespace}.firstName`,
    description: "First Name Field",
    defaultMessage: "First Name"
  },
  lastName: {
    id: `${namespace}.lastName`,
    description: "Last Name Field",
    defaultMessage: "Last Name"
  },
  phone: {
    id: `${namespace}.phone`,
    description: "Phone Field",
    defaultMessage: "Phone number"
  },
  email: {
    id: `${namespace}.email`,
    description: "Email Field",
    defaultMessage: "Email"
  },
  organization: {
    id: `${namespace}.organization`,
    description: "Organization Field",
    defaultMessage: "Organization (if applicable)"
  },
  eventDate: {
    id: `${namespace}.eventDate`,
    description: "Event Date Field",
    defaultMessage: "Date of your event"
  },
  eventDateSubtext: {
    id: `${namespace}.eventDateSubtext`,
    description: "Event Date Subtext",
    defaultMessage: "We do our best to participate in everything we can, but it’s not always possible. Try to give us at least a few weeks heads up for the best shot to collab."
  },
  requestType: {
    id: `${namespace}.requestType`,
    description: "Request Type Field",
    defaultMessage: "What is your request related to?"
  },
  requestDetails: {
    id: `${namespace}.requestDetails`,
    description: "Request Details Field",
    defaultMessage: "Tell us about your request"
  },
  requestTypeEvent: {
    id: `${namespace}.requestTypeEvent`,
    description: "Request Type Event",
    defaultMessage: "Event"
  },
  requestTypeSponsorship: {
    id: `${namespace}.requestTypeSponsorship`,
    description: "Request Type Sponsorship",
    defaultMessage: "Sponsorship"
  },
  requestTypeDonation: {
    id: `${namespace}.requestTypeDonation`,
    description: "Request Type Donation",
    defaultMessage: "Donation"
  },
  requestTypeSocialCollab: {
    id: `${namespace}.requestTypeSocialCollab`,
    description: "Request Type Social Collab",
    defaultMessage: "Social Collab"
  },
  requestTypeOther: {
    id: `${namespace}.requestTypeOther`,
    description: "Request Type Other",
    defaultMessage: "Other"
  },
});

export default partnershipInquiry;
